export { CollectibleSceneLabel } from './CollectibleSceneLabel'
